module.exports = __webpack_public_path__ + "static/GameMenu-7859c771fa58820f55c4bf2373cec93d.mp3";